(function () {
  var modal = document.getElementById('applyModal');

  if (!modal) {
    return;
  }

  var applicationForm = document.getElementById('applyForm');
  var stickyBar = document.getElementById('stickyApply');
  var mobileMenu = document.getElementById('authorityMobileMenu');
  var mobileMenuButton = document.querySelector('.hd__burger');
  var isPageSurface = modal.hasAttribute('data-apm-page');
  var calendarUrl = 'https://calendly.com/sales-demobooking/book-a-demo-clone?hide_gdpr_banner=1&primary_color=ff1f4a';
  var storageKey = 'abp4:apply';
  var legacyPendingKey = 'abp4:pending';
  var trackingKey = 'abp4:tracking';
  var firstTouchKey = 'abp_first_touch';
  var firstTouchSessionKey = 'abp_first_touch_session';
  var leadIdKey = 'abp_lead_id';
  var submittedLeadKeyPrefix = 'abp_application_submitted:';
  // After Gatehouse exposure, rollback must disable the application endpoint or
  // surface first. Never restore the native Shopify contact transport.
  var clarityEventNames = {
    abp_story_reached: true,
    abp_offer_reached: true,
    abp_application_opened: true,
    abp_application_started: true,
    abp_application_submit_attempted: true,
    abp_application_submitted: true,
    abp_call_booked: true
  };
  var app = { state: 'form', name: '', email: '' };
  var tracking = { leadId: '', isSynthetic: false, sent: {} };
  var states = {
    form: document.getElementById('apmForm'),
    sched: document.getElementById('apmSched'),
    booked: document.getElementById('apmBooked')
  };
  var lastFocusedElement = null;
  var acquisition = captureAcquisition();

  try {
    var saved = sessionStorage.getItem(storageKey);
    var savedTracking = sessionStorage.getItem(trackingKey);

    if (saved) {
      app = JSON.parse(saved);
    }

    if (savedTracking) {
      tracking = JSON.parse(savedTracking);
    }
  } catch (error) {
    app = { state: 'form', name: '', email: '' };
    tracking = { leadId: '', isSynthetic: false, sent: {} };
  }

  if (!app || !Object.prototype.hasOwnProperty.call(states, app.state)) {
    app = { state: 'form', name: '', email: '' };
  }

  if (!tracking || typeof tracking !== 'object') {
    tracking = { leadId: '', isSynthetic: false, sent: {} };
  }

  if (!tracking.sent || typeof tracking.sent !== 'object') {
    tracking.sent = {};
  }

  function clean(value, maxLength) {
    if (!value) {
      return '';
    }

    return String(value)
      .replace(/[\r\n\t]+/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim()
      .slice(0, maxLength || 255);
  }

  function clarityCommand() {
    var args = Array.prototype.slice.call(arguments);

    if (typeof window.clarity !== 'function') {
      window.clarity = function () {
        window.clarity.q = window.clarity.q || [];
        window.clarity.q.push(arguments);
      };
    }

    window.clarity.apply(window, args);
  }

  clarityCommand('set', 'funnel', 'authority-book-program');
  clarityCommand('set', 'page_version', 'v6');

  function captureAcquisition() {
    var params = new URLSearchParams(window.location.search);
    var referrerHost = '';
    var stored = null;

    if (document.referrer) {
      try {
        referrerHost = new URL(document.referrer).hostname;
      } catch (error) {
        referrerHost = '';
      }
    }

    try {
      stored = JSON.parse(localStorage.getItem(firstTouchKey));
    } catch (error) {
      stored = null;
    }

    if (!stored) {
      try {
        stored = JSON.parse(sessionStorage.getItem(firstTouchSessionKey));
      } catch (error) {
        stored = null;
      }
    }

    if (stored && typeof stored === 'object' && stored.first_touch_url) {
      var storedValues = {
        utm_source: clean(stored.utm_source),
        utm_medium: clean(stored.utm_medium),
        utm_campaign: clean(stored.utm_campaign),
        utm_content: clean(stored.utm_content),
        utm_term: clean(stored.utm_term),
        gclid: clean(stored.gclid),
        gbraid: clean(stored.gbraid),
        wbraid: clean(stored.wbraid),
        first_touch_url: clean(stored.first_touch_url, 2048),
        first_touch_at_utc: clean(stored.first_touch_at_utc, 64),
        landing_path: clean(stored.landing_path, 512),
        referrer_host: clean(stored.referrer_host)
      };

      if (!storedValues.landing_path) {
        try {
          storedValues.landing_path = clean(new URL(storedValues.first_touch_url).pathname, 512);
        } catch (error) {
          storedValues.landing_path = '';
        }
      }

      storedValues.source_class = clean(stored.source_class, 64) || sourceClass(storedValues);

      return storedValues;
    }

    var values = {
      utm_source: clean(params.get('utm_source')),
      utm_medium: clean(params.get('utm_medium')),
      utm_campaign: clean(params.get('utm_campaign')),
      utm_content: clean(params.get('utm_content')),
      utm_term: clean(params.get('utm_term')),
      gclid: clean(params.get('gclid')),
      gbraid: clean(params.get('gbraid')),
      wbraid: clean(params.get('wbraid')),
      first_touch_url: clean(window.location.href.split('#')[0], 2048),
      first_touch_at_utc: new Date().toISOString(),
      landing_path: clean(window.location.pathname, 512),
      referrer_host: clean(referrerHost)
    };

    values.source_class = sourceClass(values);

    try {
      sessionStorage.setItem(firstTouchSessionKey, JSON.stringify(values));
    } catch (error) {
      // The application still carries the current acquisition values.
    }

    return values;
  }

  function sourceClass(values) {
    var medium = (values.utm_medium || '').toLowerCase();

    if (values.gclid || values.gbraid || values.wbraid || /^(cpc|ppc|paidsearch|paid_search)$/.test(medium)) {
      return 'paid_search';
    }

    if (/^(paid_social|paidsocial|social_paid)$/.test(medium)) {
      return 'paid_social';
    }

    if (medium === 'email') {
      return 'email';
    }

    if (values.utm_source || values.utm_medium || values.utm_campaign) {
      return 'campaign';
    }

    if (values.referrer_host && values.referrer_host !== window.location.hostname) {
      return 'referral';
    }

    return 'direct';
  }

  function isThemePreview() {
    var params = new URLSearchParams(window.location.search);
    var hostname = window.location.hostname.toLowerCase();
    var themeRole = String(
      window.Shopify &&
      window.Shopify.theme &&
      window.Shopify.theme.role || ''
    ).toLowerCase();

    return Boolean(
      params.get('preview_theme_id') ||
      /\.myshopify\.com$/.test(hostname) ||
      (window.Shopify && window.Shopify.designMode) ||
      (themeRole && themeRole !== 'main')
    );
  }

  function uuidV7() {
    var bytes = new Uint8Array(16);
    var timestamp = Date.now();
    var index;

    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      window.crypto.getRandomValues(bytes);
    } else {
      for (index = 0; index < bytes.length; index += 1) {
        bytes[index] = Math.floor(Math.random() * 256);
      }
    }

    for (index = 5; index >= 0; index -= 1) {
      bytes[index] = timestamp % 256;
      timestamp = Math.floor(timestamp / 256);
    }

    bytes[6] = (bytes[6] & 15) | 112;
    bytes[8] = (bytes[8] & 63) | 128;

    return Array.prototype.map.call(bytes, function (byte) {
      return byte.toString(16).padStart(2, '0');
    }).join('').replace(
      /^(.{8})(.{4})(.{4})(.{4})(.{12})$/,
      '$1-$2-$3-$4-$5'
    );
  }

  function isUuidV7(value) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value || '');
  }

  function storedLeadId() {
    var leadId = '';

    if (isThemePreview()) {
      return '';
    }

    try {
      leadId = localStorage.getItem(leadIdKey) || '';
    } catch (error) {
      leadId = '';
    }

    return isUuidV7(leadId) ? leadId : '';
  }

  function persistLeadId(leadId) {
    if (isThemePreview() || !isUuidV7(leadId)) {
      return;
    }

    try {
      localStorage.setItem(leadIdKey, leadId);
    } catch (error) {
      // The application remains usable when persistent storage is unavailable.
    }
  }

  function claimSubmittedConversion(leadId) {
    var onceKey = 'application_submitted';

    if (tracking.sent[onceKey]) {
      return false;
    }

    try {
      var durableKey = submittedLeadKeyPrefix + leadId;

      if (localStorage.getItem(durableKey)) {
        tracking.sent[onceKey] = 'persisted';
        saveTracking();
        return false;
      }

      // Claim before emitting so a replay or fresh session cannot convert twice.
      localStorage.setItem(durableKey, 'claimed');
    } catch (error) {
      // Without durable storage, suppress the conversion rather than risk a duplicate.
      return false;
    }

    tracking.sent[onceKey] = 'claimed';
    saveTracking();
    return true;
  }

  function persistAcquisition() {
    if (isThemePreview()) {
      return;
    }

    try {
      localStorage.setItem(firstTouchKey, JSON.stringify(acquisition));
    } catch (error) {
      // The provider-backed application body remains the attribution record.
    }
  }

  function saveTracking() {
    try {
      sessionStorage.setItem(trackingKey, JSON.stringify(tracking));
    } catch (error) {
      // The form remains usable when browser storage is unavailable.
    }
  }

  function ensureLeadId() {
    if (!tracking.leadId) {
      tracking.leadId = storedLeadId() || uuidV7();
      tracking.isSynthetic = isThemePreview();
      saveTracking();
    }

    return tracking.leadId;
  }

  function addPresentFields(payload, values) {
    Object.keys(values).forEach(function (key) {
      if (values[key] !== '' && values[key] !== null && typeof values[key] !== 'undefined') {
        payload[key] = values[key];
      }
    });
  }

  function trackOpenAI(eventName, payload) {
    if (payload.is_synthetic || typeof window.oaiq !== 'function') {
      return;
    }

    var options = { event_id: payload.event_id };

    if (eventName === 'abp_page_view') {
      window.oaiq('measure', 'page_viewed', {
        type: 'contents',
        contents: [{
          id: 'authority-book-program',
          name: 'Authority Book Program',
          content_type: 'page'
        }]
      }, options);
    } else if (eventName === 'abp_application_submitted') {
      window.oaiq('measure', 'lead_created', {
        type: 'customer_action'
      }, options);
    } else if (eventName === 'abp_call_booked') {
      window.oaiq('measure', 'appointment_scheduled', {
        type: 'customer_action'
      }, options);
    }
  }

  function track(eventName, details, onceKey) {
    if (onceKey && tracking.sent[onceKey]) {
      return;
    }

    var payload = {
      event: eventName,
      event_id: uuidV7(),
      event_name: eventName,
      event_version: 1,
      occurred_at_utc: new Date().toISOString(),
      source_system: 'web',
      reporting_timezone: 'America/Toronto',
      abp_funnel_slug: 'authority-book-program',
      is_synthetic: isThemePreview() || (tracking.leadId ? Boolean(tracking.isSynthetic) : false)
    };

    if (tracking.leadId) {
      payload.abp_lead_id = tracking.leadId;
    }

    if (payload.is_synthetic) {
      payload.debug_mode = true;
    }

    addPresentFields(payload, {
      utm_source: acquisition.utm_source,
      utm_medium: acquisition.utm_medium,
      utm_campaign: acquisition.utm_campaign,
      utm_content: acquisition.utm_content,
      utm_term: acquisition.utm_term,
      gclid: acquisition.gclid,
      gbraid: acquisition.gbraid,
      wbraid: acquisition.wbraid,
      landing_path: acquisition.landing_path,
      referrer_host: acquisition.referrer_host,
      source_class: acquisition.source_class
    });
    addPresentFields(payload, details || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    trackOpenAI(eventName, payload);

    if (clarityEventNames[eventName]) {
      clarityCommand('event', eventName);
    }

    if (onceKey) {
      tracking.sent[onceKey] = payload.event_id;
      saveTracking();
    }
  }

  function trackDepthMilestones() {
    if (typeof window.IntersectionObserver !== 'function') {
      return;
    }

    var milestones = [
      {
        element: document.querySelector('[data-abp-milestone="story"]'),
        eventName: 'abp_story_reached',
        onceKey: 'story_reached'
      },
      {
        element: document.querySelector('[data-abp-milestone="offer"]'),
        eventName: 'abp_offer_reached',
        onceKey: 'offer_reached'
      }
    ];

    if (!milestones[0].element || !milestones[1].element) {
      return;
    }

    var observer = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.1) {
          return;
        }

        var milestone = entry.target === milestones[0].element ? milestones[0] : milestones[1];

        track(milestone.eventName, {}, milestone.onceKey);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    milestones.forEach(function (milestone) {
      observer.observe(milestone.element);
    });
  }

  function save() {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(app));
    } catch (error) {
      // Storage is an enhancement. The form and scheduler still work without it.
    }
  }

  function setState(nextState) {
    app.state = nextState;
    save();

    Object.keys(states).forEach(function (stateName) {
      states[stateName].hidden = stateName !== nextState;
    });

    if (nextState === 'sched') {
      mountCalendar();
    }

    if (isPageSurface) {
      window.scrollTo(0, 0);
    } else {
      modal.querySelector('.apm__dlg').scrollTop = 0;
    }
  }

  function openModal() {
    ensureLeadId();
    track('abp_application_opened', {}, 'application_opened');

    lastFocusedElement = document.activeElement;
    modal.hidden = false;

    if (!isPageSurface) {
      document.body.style.overflow = 'hidden';
    }

    setState(app.state);

    window.setTimeout(function () {
      var focusTarget = modal.querySelector('input:not([type="hidden"]), button, textarea, iframe');

      if (focusTarget) {
        focusTarget.focus();
      }
    }, 0);
  }

  function closeModal() {
    if (isPageSurface) {
      return;
    }

    modal.hidden = true;
    document.body.style.overflow = '';

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function showCalendarError() {
    var calendarWrap = document.getElementById('calWrap');

    calendarWrap.innerHTML = '<div class="apm__calph"><b>We could not load the calendar.</b><span>Please close this window and try again. Your application has already been received.</span></div>';
  }

  function mountCalendar() {
    var calendarWrap = document.getElementById('calWrap');

    if (calendarWrap.dataset.mounted) {
      return;
    }

    calendarWrap.dataset.mounted = '1';

    function initializeCalendar() {
      try {
        var leadId = ensureLeadId();

        window.Calendly.initInlineWidget({
          url: calendarUrl,
          parentElement: calendarWrap,
          prefill: {
            name: app.name,
            email: app.email
          },
          utm: {
            utmSource: 'abp',
            utmMedium: 'shopify_application',
            utmCampaign: 'calendar_offer',
            utmContent: 'abp_lead_id:' + leadId
          }
        });
      } catch (error) {
        showCalendarError();
      }
    }

    if (window.Calendly && typeof window.Calendly.initInlineWidget === 'function') {
      initializeCalendar();
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    script.onload = initializeCalendar;
    script.onerror = showCalendarError;
    document.head.appendChild(script);
  }

  function legacyPendingApplicant(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
      return null;
    }

    var name = clean(value.name, 120);
    var email = clean(value.email, 254);
    var leadId = String(value.leadId || '');

    if (
      !name ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ||
      !isUuidV7(leadId) ||
      typeof value.isSynthetic !== 'boolean'
    ) {
      return null;
    }

    return {
      name: name,
      email: email,
      leadId: leadId,
      isSynthetic: value.isSynthetic
    };
  }

  function handleLegacyAcceptedApplication() {
    var params = new URLSearchParams(window.location.search);

    if (params.get('contact_posted') !== 'true') {
      return false;
    }

    var applicant = null;

    try {
      applicant = legacyPendingApplicant(
        JSON.parse(sessionStorage.getItem(legacyPendingKey) || 'null')
      );
    } catch (error) {
      applicant = null;
    }

    if (
      !applicant ||
      (tracking.leadId && tracking.leadId !== applicant.leadId)
    ) {
      return false;
    }

    tracking.leadId = applicant.leadId;
    tracking.isSynthetic = applicant.isSynthetic;
    tracking.sent.application_submitted = 'legacy_shopify_accepted';
    saveTracking();
    persistLeadId(applicant.leadId);
    persistAcquisition();

    try {
      localStorage.setItem(
        submittedLeadKeyPrefix + applicant.leadId,
        'legacy_shopify_accepted'
      );
    } catch (error) {
      // The session guard still prevents a repeat during this return flow.
    }

    app.name = applicant.name;
    app.email = applicant.email;
    app.state = 'sched';

    try {
      sessionStorage.removeItem(legacyPendingKey);
    } catch (error) {
      // The accepted state still wins over a stale pending marker.
    }

    save();
    params.delete('contact_posted');

    var cleanUrl = window.location.pathname;
    var remainingQuery = params.toString();

    if (remainingQuery) {
      cleanUrl += '?' + remainingQuery;
    }

    cleanUrl += window.location.hash;
    window.history.replaceState({}, document.title, cleanUrl);
    openModal();
    return true;
  }

  window.AuthorityBookApplication = {
    getSubmissionContext: function () {
      return {
        leadId: ensureLeadId(),
        isSynthetic: isThemePreview() || Boolean(tracking.isSynthetic),
        attribution: acquisition
      };
    },
    acceptApplication: function (accepted) {
      var leadId = ensureLeadId();

      if (!accepted || accepted.leadId !== leadId) {
        return false;
      }

      app.name = clean(accepted.name, 120);
      app.email = clean(accepted.email, 254);
      app.state = 'sched';
      persistLeadId(leadId);
      persistAcquisition();
      if (claimSubmittedConversion(leadId)) {
        track('abp_application_submitted', {
          application_transport: 'gatehouse_helpscout'
        });
      }
      save();
      setState('sched');

      return true;
    }
  };

  document.querySelectorAll('.faq__q').forEach(function (question) {
    question.setAttribute('aria-expanded', 'false');

    question.addEventListener('click', function () {
      var row = question.parentNode;
      var wasOpen = row.classList.contains('on');

      document.querySelectorAll('.faq__row.on').forEach(function (openRow) {
        openRow.classList.remove('on');
        openRow.querySelector('.faq__q').setAttribute('aria-expanded', 'false');
      });

      if (!wasOpen) {
        row.classList.add('on');
        question.setAttribute('aria-expanded', 'true');
      }
    });
  });

  function updateStickyBar() {
    if (window.scrollY > 900) {
      stickyBar.classList.add('show');
    } else {
      stickyBar.classList.remove('show');
    }
  }

  function updateCookieOffset() {
    var height = 0;

    document.querySelectorAll('.cky-consent-container').forEach(function (container) {
      var style = window.getComputedStyle(container);
      var bounds = container.getBoundingClientRect();

      if (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        bounds.height > 0 &&
        bounds.top < window.innerHeight &&
        bounds.bottom > window.innerHeight - 8
      ) {
        height = Math.max(height, window.innerHeight - bounds.top);
      }
    });

    document.documentElement.style.setProperty('--cky-offset', Math.round(height) + 'px');
  }

  if (stickyBar) {
    window.addEventListener('scroll', updateStickyBar, { passive: true });
    window.addEventListener('resize', updateCookieOffset, { passive: true });
    new MutationObserver(updateCookieOffset).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });
    updateStickyBar();
    updateCookieOffset();
  }

  if (mobileMenuButton && mobileMenu) {
    mobileMenuButton.addEventListener('click', function () {
      var isOpen = mobileMenuButton.getAttribute('aria-expanded') === 'true';

      mobileMenuButton.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
    });

    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenuButton.setAttribute('aria-expanded', 'false');
        mobileMenu.hidden = true;
      });
    });
  }

  window.addEventListener('message', function (event) {
    if (
      event.origin === 'https://calendly.com' &&
      event.data &&
      event.data.event === 'calendly.event_scheduled'
    ) {
      var calendlyPayload = event.data.payload || {};

      track('abp_call_booked', {
        calendly_event_uri: clean(calendlyPayload.event && calendlyPayload.event.uri, 512),
        calendly_invitee_uri: clean(calendlyPayload.invitee && calendlyPayload.invitee.uri, 512)
      }, 'call_booked');
      setState('booked');
    }
  });

  document.querySelectorAll('a[href="/pages/authority-book-program-application"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      openModal();
    });
  });

  modal.querySelectorAll('[data-apm-close]').forEach(function (closeControl) {
    closeControl.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });

  function handleApplicationInteraction(event) {
    if (!event.target.matches('input:not([type="hidden"]), textarea, select')) {
      return;
    }

    track('abp_application_started', {}, 'application_started');
  }

  applicationForm.addEventListener('input', handleApplicationInteraction);
  applicationForm.addEventListener('change', handleApplicationInteraction);

  applicationForm.querySelector('.apm__submit').addEventListener('click', function () {
    track('abp_application_submit_attempted', {}, 'application_submit_attempted');
  });

  applicationForm.addEventListener('submit', function () {
    track('abp_application_submit_attempted', {}, 'application_submit_attempted');
  });

  trackDepthMilestones();

  track('abp_page_view', {
    page_path: window.location.pathname
  });

  if (!handleLegacyAcceptedApplication() && isPageSurface) {
    ensureLeadId();
    track('abp_application_opened', {}, 'application_opened');
    setState(app.state);
  }
})();
